import { UserResponse } from '../types/responses/user-response';
import { GetAllAsync } from './api';
import { KendoGridResult } from '../types/KendoGridResult';
import { State, toDataSourceRequestString } from '@progress/kendo-data-query';
import { UserPermissionsResponse } from '../types/responses/user-permissions-response';
import { Facilitator } from '../types/user';

const UserEndpoint = `admin/users`;
const FacilitatorEndpoint = `admin/facilitators`;

export const GetGridAllUsersAsync = async (dataState: State) =>
  GetAllAsync<KendoGridResult<UserResponse>>(
    `${UserEndpoint}?${toDataSourceRequestString(dataState)}`
  );

export const GetReportsAllUsersAsync = async () =>
  GetAllAsync<UserResponse>(`${UserEndpoint}/reports`);

export const GetGridAdminFacilitatorsAsync = async (dataState: State) =>
  GetAllAsync<KendoGridResult<Facilitator>>(
    `${FacilitatorEndpoint}?${toDataSourceRequestString(dataState)}`
  );

export const GetReportsAdminFacilitatorsAsync = async () =>
  GetAllAsync<Facilitator>(`${FacilitatorEndpoint}/reports`);

export const GetGridAllUserPermissionsAsync = async (dataState: State) =>
  GetAllAsync<KendoGridResult<UserPermissionsResponse>>(
    `${UserEndpoint}/permissions?${toDataSourceRequestString(dataState)}`
  );

export const GetReportsAllUserPermissionsAsync = async () =>
  GetAllAsync<KendoGridResult<UserPermissionsResponse>>(
    `${UserEndpoint}/permissions/reports`
  );
